import { render, staticRenderFns } from "./CreateManager.vue?vue&type=template&id=58cf4740&scoped=true"
import script from "./CreateManager.vue?vue&type=script&lang=ts"
export * from "./CreateManager.vue?vue&type=script&lang=ts"
import style0 from "./CreateManager.vue?vue&type=style&index=0&id=58cf4740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf4740",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer,VFlex,VLayout})
